
<template>
  <v-card elevation="0">
    <v-card-text>
      <v-container grid-list-lg fill-height>
        <v-form ref="form" enctype="multipart/form-data" novalidate v-model="valid">
          <v-layout wrap>
            <v-flex xs12 sm6>
              <v-text-field
                label="Dispositivo"
                :value="deviceName"
                disabled
                />
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field
                label="Peso Total"
                v-model="measurement.weight"
                disabled
                />
            </v-flex>
            <v-flex xs12 sm6>
              <v-select
                flat
                :items="materials"
                v-model="materialId"
                label="Materia Prima"
                item-value="id"
                item-text="name"
                disabled
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6>
              <date-picker
                :date.sync="startDate"
                label="Fecha comienzo"
                disabled/>
            </v-flex>
            <v-flex xs12 sm6>
              <time-picker
                :time.sync="startTime"
                label="Hora comienzo"
                disabled/>
            </v-flex>
            <v-flex xs12 sm6>
              <date-picker
                :date.sync="endDate"
                label="Fecha fin"
                disabled/>
            </v-flex>
            <v-flex xs12 sm6>
              <time-picker
                :time.sync="endTime"
                label="Hora fin"
                disabled/>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                label="Comentarios"
                v-model="measurement.comment"/>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="pa-3">
      <v-spacer></v-spacer>
      <v-btn
        color="accent"
        large
        depressed
        @click="submit"
        :disabled="!valid"
        :loading="loading"
        >
          Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import api from '@/api/app'
import formMixin from '@/mixins/formMixin'
import mutationsMixin from '@/mixins/mutationsMixin'

export default {
  name: 'Measurement',
  mixins: [formMixin, mutationsMixin],
  mounted () {
    let p1 = api.getMeasurement(this.$route.params.id).then(response => {
      this.measurement = response
      if (this.measurement.measurement_type !== 'full') {
        this.$router.push({name: 'measurement-list'})
      }
      this.materialId = this.measurement.material ? this.measurement.material.id : ''
      this.$store.state.pageTitle = 'Pesadas | ' + this.measurement.code
    })

    let p2 = api.getProcessTypeRawMaterials(3).then(response => {
      this.materials = response
    })

    Promise.all([p1, p2]).then(() => {
      this.loading = false
    })
  },
  computed: {
    deviceName () {
      return this.measurement.device ? this.measurement.device.name : ''
    },
    submitData () {
      return {
        comment: this.measurement.comment
      }
    }
  },
  data () {
    return {
      errors: {},
      loading: false,
      startDate: null,
      startTime: null,
      endDate: null,
      endTime: null,
      materialId: null,
      measurement: {},
      materials: []
    }
  },
  methods: {
    onSubmit () {
      return api.editMeasurement(this.measurement.id, this.submitData)
    },
    onSuccess () {
      this.success('Pesada actualizada con éxito')
    }
  },
  watch: {
    measurement () {
      const startDateTime = this.$options.filters.splitDateTime(this.measurement.start)
      if (startDateTime) {
        this.startDate = startDateTime.date
        this.startTime = startDateTime.time
      }
      const endDateTime = this.$options.filters.splitDateTime(this.measurement.end)
      if (endDateTime) {
        this.endDate = endDateTime.date
        this.endTime = endDateTime.time
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Measurement.vue